<template>
  <div class="print">
    <div class="printTitle">
      <div v-for="(v,i) in printer" :key="i" class="printerItem">
        <span>{{v.status}}</span>
        <img :src="v.imgurl" alt="" width="101px" height="94px">
        <span style="color:#666">{{v.name}}</span>
      </div>
      <div class="goback">
        <div class="backbtn">
          <i class="el-icon-refresh-left" style="font-size:28px; margin-bottom: 18px;"></i>
          <span style="font-size:16px; margin-bottom: 64px;">返回</span>
        </div>
        <div class="backName">
          <span style="margin-bottom:10px">2021-07-16</span>
          <span>Merlin</span>
        </div>
      </div>
    </div>
    <div class="mainTable">
      <div class="rightTitle">
        <div class="Tool">
          <div class="titleItem" v-for="(v,i) in titleList" :key="i" :class="currentTitle == i ? 'titleItemCurrent' : '' " @click="todayOrhistory(i)"> {{v}} </div>

        </div>
        <div class="FunctionalityBtn">
          <el-input v-model="input" placeholder="桌号" style="width:250px;margin-right:20px"></el-input>
          <el-input v-model="input" placeholder="单号" style="width:250px;margin-right:20px"></el-input>
          <div class="feffBtn">查询</div>
        </div>
      </div>
      <div class="tableMain">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="date" label="单号" width="180">
          </el-table-column>
          <el-table-column prop="name" label="营业点/桌号" width="180">
          </el-table-column>
          <el-table-column prop="address" label="菜类"></el-table-column>
          <el-table-column prop="address" label="菜名"></el-table-column>
          <el-table-column prop="address" label="数量 "></el-table-column>
          <el-table-column prop="address" label="单位"></el-table-column>
          <el-table-column prop="address" label="打印"></el-table-column>
          <el-table-column prop="address" label="打印机"></el-table-column>
          <el-table-column prop="address" label="点菜员"></el-table-column>
          <el-table-column prop="address" label="点菜时间"></el-table-column>
          <el-table-column prop="address" label="打印时间"></el-table-column>
          <el-table-column prop="address" label="打印时长"></el-table-column>
          <el-table-column prop="address" label="要求"></el-table-column>
        </el-table>
      </div>
      <div class="tablefooter">
        <div class="continue">
          <img src="../../../assets/imgs/stop.png" width="24px" height="24px" alt="">
          <span style="margin-left:20px">继续打印</span>
        </div>
        <div class="BottomBackBtn">
          退出
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData:[
        {date:1},
     
      ],
      titleList: ['未打印菜品', '已打印菜品'],
      currentTitle: 1,
      printer: [
        { status: '联机', imgurl: require('../../../assets/imgs/print.png'), name: '热菜1001' },
      
      ]
    }
  },
  methods: {
    todayOrhistory(i) {
      this.currentTitle = i
    },
  }
}
</script>

<style lang="scss" scoped>
.print {
  width: 100%;
  height: 100%;
  background: #fafafa;
  .printTitle {
    height: 270px;
    display: flex;
    align-items: center;
    padding: 0 0 0 20px;
    .printerItem {
      display: flex;
      font-size: 24px;
      flex-direction: column;
      width: 200px;
      height: 230px;
      background: #fff;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      border: 1px solid #e4e4e4;
      margin-right: 20px;
      img {
        margin: 10px 0 20px;
      }
      span:nth-child(1) {
        color: #0099ff;
      }
    }
    .goback {
      width: 145px;
      height: 100%;
      background: #ffffff;
      border: 1px solid #eaeaea;
      color: #666;
      .backbtn {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 52px;
      }
      .backName {
        width: 100%;
        display: flex;
        flex-direction: column;

        align-items: center;
      }
    }
  }
  .mainTable {
    width: 100%;
    height: calc(100vh - 270px);
    background: #fff;
    display: flex;
    flex-direction: column;
    .rightTitle {
      border-bottom: 1px solid #eaeaea;
      display: flex;
      // height: 66px;
      flex: 0 0 66px;
      width: 100%;
      align-items: center;
      padding: 0 10px 0 30px;
      justify-content: space-between;
      .Tool {
        display: flex;
        .titleItem {
          width: 180px;
          height: 40px;
          border-radius: 33px;
          background: #fff;
          text-align: center;
          cursor: pointer;
          line-height: 40px;
          margin-right: 10px;
        }
        .titleItemCurrent {
          background: #0099ff;
          color: #fff;
        }
      }

      .FunctionalityBtn {
        display: flex;
        .feffBtn {
          width: 120px;
          height: 40px;
          background: linear-gradient(225deg, #ffbe34 0%, #fe812f 100%);
          box-shadow: 0px 2px 10px 0px rgba(254, 137, 47, 0.3);
          border-radius: 38px;
          text-align: center;
          cursor: pointer;
          color: #fff;
          line-height: 40px;
          margin: 0 5px;
        }
        .blueBtn {
          width: 70px;
          height: 40px;
          background: #0099ff;
          box-shadow: 0px 2px 5px 0px rgba(0, 153, 255, 0.3);
          margin: 0 5px;
          border-radius: 30px;
          text-align: center;
          cursor: pointer;
          color: #fff;
          line-height: 40px;
        }
      }
    }
    /deep/.el-input__inner {
      font-size: 24px;
      background: #eee;
      color: #666;
    }
    .tableMain {
      flex: 1;
      overflow: auto;
      /deep/.el-table thead{
        color: #666;
      }
    }
    .tablefooter {
      // height: 100px;
      flex: 0 0 100px;
      background: #ffffff;
      border: 1px solid #e8e8e8;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      .continue {
        display: flex;
        align-items: center;
        color: #666;
      }
      .BottomBackBtn {
        width: 200px;
        height: 60px;
        background: linear-gradient(225deg, #ffbe34 0%, #fe812f 100%);
        box-shadow: 0px 2px 10px 0px rgba(254, 137, 47, 0.3);
        border-radius: 38px;
        text-align: center;
        line-height: 60px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
</style>